(function() {
  var DEFAULT_LIMIT = 5;
  var GIFT_CARD_LIMIT = 4;
  var GIFT_CARD_MOBILE_LIMIT = 2;
  var MOBILE_LIMIT = 4;
  var hideLabel = "Hide";
  var chevronDown = '<svg aria-hidden="true" class="icon icon-chevron-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg>';
  var chevronUp = '<svg aria-hidden="true" class="icon icon-chevron-up" viewBox="0 0 32 32"><path class="stroke" d="M5,22,16,10,27,22"/></svg>';

  function isMobileViewport() {
    if (document.body.classList.contains('is-mobile')) {
      return true;
    }
    if (window.breakpoints && window.breakpoints.medium) {
      return window.matchMedia('(max-width: ' + window.breakpoints.medium + ')').matches;
    }
    return false;
  }

  function getSwatchLimit(drawer) {
    var productCard = drawer.closest('.product-card, product-card-atc');
    var productType = productCard && productCard.dataset.productType;
    var optionLabel = drawer.dataset.label || '';
    var isGiftCard = (productType && /gift/i.test(productType)) || /gift/i.test(optionLabel);
    var limit = DEFAULT_LIMIT;
    if (isGiftCard) {
      limit = GIFT_CARD_LIMIT;
    }
    if (isMobileViewport()) {
      if (isGiftCard) {
        return GIFT_CARD_MOBILE_LIMIT;
      }
      return Math.min(limit, MOBILE_LIMIT);
    }
    return limit;
  }

  function updateShowButtonCount(drawer, group) {
    var showBtn = group.querySelector('.swatch-drawer-show');
    if (!showBtn) {
      return;
    }
    var swatches = getSwatchItems(group);
    var limit = getSwatchLimit(drawer);
    var countEl = showBtn.querySelector('.swatch-drawer-count');
    if (countEl && swatches.length > limit) {
      countEl.textContent = (swatches.length - limit) + '+';
    }
  }

  function refreshDrawerLimits() {
    document.querySelectorAll('.product-card-swatch-drawer').forEach(function(drawer) {
      var group = drawer.matches('.swatch-group') ? drawer : drawer.querySelector('.swatch-group');
      if (!group) {
        return;
      }
      updateShowButtonCount(drawer, group);
      if (!drawer.classList.contains('is-open')) {
        updateCollapsedVisibility(drawer, group);
      }
    });
  }

  function getSwatchItems(group) {
    return [...group.querySelectorAll(':scope > .swatch')].filter(function(swatch) {
      return swatch.querySelector('input[type="radio"]') && !swatch.classList.contains('swatch-drawer-show');
    });
  }

  function updateCollapsedVisibility(drawer, group) {
    if (drawer.classList.contains('is-open')) {
      return;
    }
    var limit = getSwatchLimit(drawer);
    var swatches = getSwatchItems(group);
    if (swatches.length <= limit) {
      swatches.forEach(function(swatch) {
        swatch.classList.remove('swatch-drawer-collapsed-hidden');
      });
      return;
    }
    var checkedSwatch = group.querySelector('input[type="radio"]:checked')?.closest('.swatch');
    var visible = new Set();
    if (checkedSwatch && swatches.indexOf(checkedSwatch) !== -1) {
      visible.add(checkedSwatch);
    }
    swatches.forEach(function(swatch) {
      if (visible.size >= limit) {
        return;
      }
      visible.add(swatch);
    });
    swatches.forEach(function(swatch) {
      swatch.classList.toggle('swatch-drawer-collapsed-hidden', !visible.has(swatch));
    });
  }

  function updateShadeValue(drawer, group) {
    var checked = group.querySelector('input[type="radio"]:checked');
    var shadeValue = checked ? checked.value : '';
    var productCard = drawer.closest('.product-card');
    var titleShade = productCard ? productCard.querySelector('[data-product-card-shade]') : null;
    if (titleShade && shadeValue) {
      titleShade.textContent = shadeValue;
    }
  }

  function openDrawer(drawer, group) {
    drawer.classList.add('is-open');
    getSwatchItems(group).forEach(function(swatch) {
      swatch.classList.remove('swatch-drawer-collapsed-hidden');
    });
    updateShadeValue(drawer, group);
  }

  function closeDrawer(drawer, group) {
    drawer.classList.remove('is-open');
    updateCollapsedVisibility(drawer, group);
  }

  function bindShadeLabel(drawer, group) {
    var productCard = drawer.closest('.product-card');
    if (!productCard || !productCard.querySelector('[data-product-card-shade]')) {
      return;
    }
    if (group.dataset.shadeLabelBound) {
      return;
    }
    group.dataset.shadeLabelBound = 'true';
    group.addEventListener('change', function(event) {
      if (!event.target.matches('input[type="radio"]')) {
        return;
      }
      updateShadeValue(drawer, group);
    });
    updateShadeValue(drawer, group);
  }

  function enhanceGroup(drawer, group) {
    if (drawer.dataset.swatchDrawerEnhanced) {
      return;
    }

    var swatches = getSwatchItems(group);
    bindShadeLabel(drawer, group);

    var limit = getSwatchLimit(drawer);
    if (swatches.length <= limit) {
      drawer.dataset.swatchDrawerEnhanced = 'skip';
      return;
    }

    drawer.dataset.swatchDrawerEnhanced = 'true';
    drawer.classList.add('product-card-swatch-drawer');
    var productCard = drawer.closest('.product-card');
    if (productCard) {
      productCard.classList.add('product-card-swatch-drawer-ready');
    }

    group.querySelector('.swatch-remaining')?.remove();

    var header = document.createElement('div');
    header.className = 'swatch-drawer-header';
    header.innerHTML = '<button type="button" class="swatch-drawer-hide"><span class="swatch-drawer-hide-label">' + hideLabel + '</span><span class="swatch-drawer-chevron" aria-hidden="true">' + chevronUp + '</span></button>';
    group.parentNode.insertBefore(header, group);
    header.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(drawer, group);
      showBtn.setAttribute('aria-expanded', 'false');
    });

    var showBtn = document.createElement('button');
    showBtn.type = 'button';
    showBtn.className = 'swatch swatch-drawer-show flex align-items-center';
    showBtn.setAttribute('aria-expanded', 'false');
    showBtn.innerHTML = '<span class="swatch-drawer-count">' + (swatches.length - limit) + '+</span><span class="swatch-drawer-chevron" aria-hidden="true">' + chevronDown + '</span>';
    group.appendChild(showBtn);

    drawer.addEventListener('click', function(event) {
      if (event.target.closest('.swatch-drawer-show')) {
        event.preventDefault();
        openDrawer(drawer, group);
        showBtn.setAttribute('aria-expanded', 'true');
      } else if (event.target.closest('.swatch-drawer-hide')) {
        event.preventDefault();
        closeDrawer(drawer, group);
        showBtn.setAttribute('aria-expanded', 'false');
      }
    });

    group.addEventListener('change', function(event) {
      if (!event.target.matches('input[type="radio"]')) {
        return;
      }
      updateShadeValue(drawer, group);
      if (!drawer.classList.contains('is-open')) {
        updateCollapsedVisibility(drawer, group);
      }
    });

    updateShadeValue(drawer, group);
    updateCollapsedVisibility(drawer, group);
  }

  function whenSwatchGroupReady(drawer, group, callback) {
    if (getSwatchItems(group).length > 0) {
      callback();
      return;
    }
    var tries = 0;
    var interval = setInterval(function() {
      tries++;
      var count = getSwatchItems(group).length;
      if (count > 0 || tries > 40) {
        clearInterval(interval);
        if (count > 0) {
          callback();
        } else {
          drawer.dataset.swatchDrawerEnhanced = 'skip';
        }
      }
    }, 50);
  }

  function enhanceProductSwatch(swatchEl) {
    if (swatchEl.dataset.swatchDrawerEnhanced) {
      return;
    }
    var group = swatchEl.querySelector('.swatch-group');
    if (!group) {
      return;
    }
    whenSwatchGroupReady(swatchEl, group, function() {
      enhanceGroup(swatchEl, group);
    });
  }

  function enhanceInlineGroup(group) {
    if (group.dataset.swatchDrawerEnhanced) {
      return;
    }
    whenSwatchGroupReady(group, group, function() {
      enhanceGroup(group, group);
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-card-atc product-swatch, .product-card.atc product-swatch').forEach(enhanceProductSwatch);
    scope.querySelectorAll('.product-card .inline-swatch-group.color-swatches').forEach(enhanceInlineGroup);
  }

  $s.initProductCardSwatchDrawers = scan;

  if (window.$s && typeof $s.resizeWidthHandle === 'function') {
    $s.resizeWidthHandle(refreshDrawerLimits, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { scan(); });
  } else {
    scan();
  }

  setTimeout(function() { scan(); }, 100);
  setTimeout(function() { scan(); }, 500);
  setTimeout(function() {
    if (!window.$s || typeof $s.matchHeightByRow !== 'function') {
      return;
    }
    $s.matchHeightByRow(document.querySelectorAll('.product-card .info-inner'), { groupByCardTop: true });
    $s.matchHeightByRow(document.querySelectorAll('.product-card .product-card-variants-row'), { groupByCardTop: true });
    $s.matchHeightByRow(document.querySelectorAll('.product-card .metafield-subtitle-product'), { groupByCardTop: true });
    $s.matchHeightByRow(document.querySelectorAll('.product-card .info'), { groupByCardTop: true });
  }, 600);
})();
